import { SeatInfo } from '../models/serializable/seating-state/seat-info.js';
import { SeatingStateBase } from '../models/serializable/seating-state/seating-state-base.js';

export class SeatingStateHelper {
  constructor(
    public readonly state: SeatingStateBase,
  ) {}

  getSeatInfo(seatId: number): SeatInfo {
    if(seatId < 0) {
      throw new Error(`Invalid seat ID: ${seatId}`);
    }

    this.ensureInitializedUpTo(seatId);

    return this.state.seats[seatId];
  }

  updateSeatInfo(
      seatId: number,
      updateFn: (currentValue: SeatInfo) => void,
  ): void {
    if(seatId < 0) {
      throw new Error(`Invalid seat ID: ${seatId}`);
    }

    this.ensureInitializedUpTo(seatId);

    updateFn(this.state.seats[seatId]);
  }

  swapSeatInfo(
      originalSeatId: number,
      destinationSeatId: number,
      test?: (original: SeatInfo, destination: SeatInfo) => boolean,
  ): boolean {
    if(originalSeatId < 0) {
      throw new Error(`Invalid seat ID: ${originalSeatId}`);
    }
    if(destinationSeatId < 0) {
      throw new Error(`Invalid seat ID: ${destinationSeatId}`);
    }

    this.ensureInitializedUpTo(Math.max(originalSeatId, destinationSeatId));
    const originalSeatInfo = this.state.seats[originalSeatId];
    const destinationSeatInfo = this.state.seats[destinationSeatId];

    if(test != null && !test(originalSeatInfo, destinationSeatInfo)) {
      return false;
    }

    this.state.seats[destinationSeatId] = originalSeatInfo;
    this.state.seats[originalSeatId] = destinationSeatInfo;

    return true;
  }

  private ensureInitializedUpTo(seatId: number): void {
    if(seatId < 0) {
      return;
    }

    if(seatId < this.state.seatCount) {
      return;
    }

    for(let i = this.state.seatCount; i <= seatId; i++) {
      this.state.seats.push(SeatInfo.free(i));
    }
  }
}
